import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=f84649ae&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f84649ae')) {
      api.createRecord('f84649ae', component.options)
    } else {
      api.reload('f84649ae', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=f84649ae&", function () {
      api.rerender('f84649ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MNuX5tdLd1tY/JS/comp/openstreetmap.vue"
export default component.exports